{
    "buddha": {
        "playlist": "PLgQIYTIJXpzbk3yXKEhePNfxRsU7wvmOw",
        "youtube": [
            "https://www.youtube.com/embed/UseFVmrX1z0?si=n58IPMi3uzIcLXpr&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1",
            "https://www.youtube.com/embed/xJJjXgtYmeo?si=l3zMjSF54pfbsDkn&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1",
            "https://www.youtube.com/embed/iiYy4Afc-Pk?si=gaX06QUB03h4hNSf&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1",
            "https://www.youtube.com/embed/TvlNK5ZaFCw?si=e630SrSv4X3HPh4K&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1",
            "https://www.youtube.com/embed/-ozOCVqUHHk?si=nXXt3EH8UDZy3TNM&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1"
        ],
        "dropbox": [
            "https://dl.dropboxusercontent.com/scl/fi/fzb6vpouosg7i7fgxqjvo/FINALBUDDA1.mp4?rlkey=qr18bc6qsqz06m47wh9okbb8r&st=6iiy98d1&raw=1",
            "https://dl.dropboxusercontent.com/scl/fi/imkpoagi4sx4n2ksrdvcs/FINALBUDDA2.mp4?rlkey=4morlebuup680my5r4xfogo41&st=r80uptr6&raw=1",
            "https://dl.dropboxusercontent.com/scl/fi/m8q3jo1xse5wbljj9r6rh/FINALBUDDA3.mp4?rlkey=ue7xeq92y6dmr6i4j9dyipu56&st=yqdmaxs3&raw=1",
            "https://dl.dropboxusercontent.com/scl/fi/r3xled0zw45r6hq9b1kkh/FINALBUDDA4.mp4?rlkey=8ymvh04t9ou44dqbcnb5diyxo&st=mazkz2nt&raw=1",
            "https://dl.dropboxusercontent.com/scl/fi/jnks7j4quuqn4k6527fvq/FINALBUDDA5.mp4?rlkey=9sqxhz3ih7w010zuforgazrqe&st=ikoowulc&raw=1"
        ],
        "checksum": [
            "894fc0c8b9533d66",
            "3b5243f541f14de2",
            "af5b26ce37938d5d",
            "34be5314d59f9cb9",
            "e6bc2f56ef861090"
        ],
        "checksum2": [
            "34b57e6829d85b367516bd3328034462c809c04eab42835ac99865be8cec5ff1",
            "d314d4d960d74a28787b6d5605197d97a239630b096c830c8783b4995f04ca67",
            "cba6dd205d07569083c5e41a4ef9ac0484587c5708dc9cfb4821b3b1bcf59b0f",
            "5a48015e3610ff45d0a4a34334fe63ce714acd643306dd228c1a6742638c0f65",
            "80338c97e0e01d4ad0b7de0b5a8469667079f37ca2ae53c07f2a11557a2a560a"
        ]
    }
}
